import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portfolio-mobile-footer',
  templateUrl: './portfolio-mobile-footer.component.html',
  styleUrls: ['./portfolio-mobile-footer.component.scss']
})
export class PortfolioMobileFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
